import { getConfig } from '@edx/frontend-platform';
import Header from '@edx/frontend-component-header';

import { useMenuItems } from './hooks/useMenuItems';

const CatalogHeader = () => {
  const { mainMenu, secondaryMenu } = useMenuItems();

  return (
    <Header
      logo={getConfig().LOGO_URL}
      logoAltText={getConfig().SITE_NAME}
      logoDestination={`${getConfig().LMS_BASE_URL}/`}
      mainMenuItems={mainMenu}
      secondaryMenuItems={secondaryMenu}
    />
  );
};

export default CatalogHeader;
